import FroalaEditor from 'froala-editor';

FroalaEditor.RegisterCommand('formatOLSweet', {
  title: 'Ordered List',
  hasOptions: function (this: FroalaEditor) {
    return this.opts.listAdvancedTypes;
  },
  options: {
    default: 'Default',
    'lower-alpha': 'Alpha',
    'lower-roman': 'Roman',
  },
  refresh: function (this: FroalaEditor, e) {
    this.lists.refresh(e, 'OL');
  },
  callback: function (this: FroalaEditor, e, t) {
    this.lists.format('OL', t);
  },
  plugin: 'lists',
});

FroalaEditor.DefineIcon('formatOLSweet', {
  NAME: 'list-ol',
  SVG_KEY: 'orderedList',
});
